import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect
} from 'react-router-dom'

/*CSS*/
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './App.css';

/*Components*/
import Header from './Components/GameHeader';
import Footer from './Components/GameFooter';

/*Pages*/
import GameMainPage from './Pages/GameMainPage';
import ContentCreators from './Pages/ContentCreators';
import PressKit from './Pages/PressKit';
import EULA from './Pages/EULA';
import Policy from './Pages/Policy';
import DiscordPolicy from './Pages/DiscordPolicy';

//const server = require('./server');
//server.initialize();

class App extends React.Component {
    
    render() {
        return (
            <Router>
                <div className="App">
                    <Header />

                    <Route exact path='/' component={GameMainPage} />
                    <Route exact path='/Content-Creators' component={ContentCreators} />
                    <Route exact path='/Press-Kit' component={PressKit} />
                    <Route exact path='/EULA' component={EULA} />
                    <Route exact path='/Policy' component={Policy} />
                    <Route exact path='/discord/policy' component={DiscordPolicy} />

                      {/* Console store redirects - replace '/' with store URLs when available */}
                      <Route exact path='/ps5' component={() => {
                          window.location.href = 'https://store.playstation.com/concept/10016956';
                          return null;
                      }} />
                      <Route exact path='/xbox' component={() => {
                          window.location.href = 'https://www.xbox.com/games/store/dark-hours/9mvz0d78z5tw';
                          return null;
                      }} />

{/*
                      <Route exact path='/ps5' render={() => <Redirect to='/' />} />
                      <Route exact path='/xbox' render={() => <Redirect to='/' />} />
*/}

                    <Footer />

                </div>
            </Router>

        );
    }
}


export default App;
